import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconMultipleLayers = (props) => (
  <SVG
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1965_1264)">
      <path
        d="M18.7375 9.14583L9.99996 14.3892L1.26246 9.14583C1.07294 9.03212 0.846011 8.99835 0.631594 9.05195C0.417178 9.10556 0.232837 9.24214 0.119126 9.43166C0.00541403 9.62118 -0.028354 9.84811 0.0252502 10.0625C0.0788543 10.2769 0.21544 10.4613 0.404959 10.575L9.57163 16.075C9.70124 16.1529 9.84959 16.194 10.0008 16.194C10.152 16.194 10.3004 16.1529 10.43 16.075L19.5966 10.575C19.7861 10.4613 19.9227 10.2769 19.9763 10.0625C20.0299 9.84811 19.9962 9.62118 19.8825 9.43166C19.7687 9.24214 19.5844 9.10556 19.37 9.05195C19.1556 8.99835 18.9286 9.03212 18.7391 9.14583H18.7375Z"
        fill="#434B5D"
      />
      <path
        d="M18.7375 12.9525L9.99996 18.195L1.26246 12.9525C1.16862 12.8962 1.0646 12.8589 0.956361 12.8428C0.848117 12.8267 0.73776 12.8321 0.631592 12.8586C0.525423 12.8852 0.425523 12.9324 0.337593 12.9975C0.249664 13.0627 0.175427 13.1445 0.119123 13.2383C0.0628189 13.3322 0.0255492 13.4362 0.009442 13.5444C-0.00666517 13.6527 -0.00129439 13.763 0.0252477 13.8692C0.0788518 14.0836 0.215437 14.268 0.404956 14.3817L9.57162 19.8817C9.70123 19.9595 9.84959 20.0007 10.0008 20.0007C10.152 20.0007 10.3003 19.9595 10.43 19.8817L19.5966 14.3817C19.7861 14.268 19.9227 14.0836 19.9763 13.8692C20.0299 13.6548 19.9962 13.4279 19.8825 13.2383C19.7687 13.0488 19.5844 12.9122 19.37 12.8586C19.1556 12.805 18.9286 12.8388 18.7391 12.9525H18.7375Z"
        fill="#434B5D"
      />
      <path
        d="M9.99998 12.3108C9.55046 12.3106 9.10947 12.1882 8.72415 11.9567L0.404147 6.96417C0.280937 6.89009 0.17899 6.78538 0.108214 6.66024C0.0374394 6.5351 0.000244141 6.39378 0.000244141 6.25001C0.000244141 6.10624 0.0374394 5.96491 0.108214 5.83977C0.17899 5.71463 0.280937 5.60993 0.404147 5.53584L8.72415 0.543339C9.10946 0.311863 9.55049 0.189575 9.99998 0.189575C10.4495 0.189575 10.8905 0.311863 11.2758 0.543339L19.5958 5.53584C19.719 5.60993 19.821 5.71463 19.8917 5.83977C19.9625 5.96491 19.9997 6.10624 19.9997 6.25001C19.9997 6.39378 19.9625 6.5351 19.8917 6.66024C19.821 6.78538 19.719 6.89009 19.5958 6.96417L11.2758 11.9567C10.8905 12.1882 10.4495 12.3106 9.99998 12.3108ZM2.45331 6.25001L9.58331 10.5275C9.70924 10.6028 9.85324 10.6426 9.99998 10.6426C10.1467 10.6426 10.2907 10.6028 10.4166 10.5275L17.5466 6.25001L10.4166 1.97251C10.2907 1.89718 10.1467 1.8574 9.99998 1.8574C9.85324 1.8574 9.70924 1.89718 9.58331 1.97251L2.45331 6.25001Z"
        fill="#434B5D"
      />
    </g>
    <defs>
      <clipPath id="clip0_1965_1264">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SVG>
)

export default withIconStyles(IconMultipleLayers)
